'use strict';
import { app } from '../../../../../../../bootstrap/core';

import atruviaUserDataModalComponent from './atruviaUserDataModal.component';
import { AtruviaUserDataModalService } from './atruviaUserDataModal.service';

app.component('atruviaUserDataModalComponent', atruviaUserDataModalComponent);
app.service('atruviaUserDataModalService', AtruviaUserDataModalService);
